module.exports = __webpack_public_path__ + "static/media/general.3870bdc7.svg";